import axios from 'axios';
import endpointNames from "../configs/serverUrls";

const baseUrl = endpointNames.allocate.accident;

//gets token from localStorage
let token = JSON.parse(localStorage.getItem('token'));

//allocate
const allocatePlan = async (request) => {
    let response;
    await axios.post(baseUrl + 'allocate-accident', request, {

        headers: {Authorization: `Bearer ${token}`},
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}


export default {
   allocatePlan
}
